import { useQueryClient } from '@tanstack/react-query'
import {
  usePutAdminsMedicationsMedicationGlobalKey,
  getGetAdminsMedicationsQueryKey,
  getGetAdminsMedicationsMedicationGlobalKeyQueryKey,
  usePostAdminsMedicationsImages,
} from '@/api/generated/medication/medication'
import type { MedicationStaffApiOutContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'
import type { UpdateMedicationInput } from '../types'
import { mapMedicationIn, mapInToOut } from './adapters'

export function useUpdateMedication() {
  const queryClient = useQueryClient()
  const { mutateAsync: orvalMutateAsync, isPending: isUpdating } = usePutAdminsMedicationsMedicationGlobalKey()
  const { mutateAsync: uploadImage, isPending: isUploading } = usePostAdminsMedicationsImages()

  async function mutateAsync(data: UpdateMedicationInput): Promise<void> {
    let imageUrl = data.existingImageUrl ?? ''
    if (data.medicationImage) {
      const result = await uploadImage({ data: { image: data.medicationImage } })
      imageUrl = result.ImageUrl ?? ''
    }
    const apiData = mapMedicationIn(data, imageUrl)
    await orvalMutateAsync({ medicationGlobalKey: data.id, data: apiData })

    const optimistic = mapInToOut(data.id, apiData)

    const listKey = getGetAdminsMedicationsQueryKey()
    queryClient.setQueryData<MedicationStaffApiOutContract[]>(listKey, (old) =>
      (old ?? []).map((m) => (m.Id === data.id ? optimistic : m)),
    )

    const detailKey = getGetAdminsMedicationsMedicationGlobalKeyQueryKey(data.id)
    queryClient.setQueryData<MedicationStaffApiOutContract>(detailKey, optimistic)

    queryClient.invalidateQueries({ queryKey: listKey })
    queryClient.invalidateQueries({ queryKey: detailKey })
  }

  return { mutateAsync, isPending: isUpdating || isUploading }
}
